<mat-checkbox class="mat-form-field-infix" fxFlex="100" name="intro" [formControl]="checkedControl" [disabled]="canEdit === false">{{title}}</mat-checkbox>
<mat-form-field fxFlex="100" *ngIf="checked">
    <input matInput 
        name="introWords" 
        placeholder="Number of Words" 
        [formControl]="countControl" 
        [matAutocomplete]="countAuto"
        [readonly]="canEdit === false" 
        name="saveViewIntroWords"
        autocomplete="saveViewIntroWords"
        id="saveViewIntroWords{{saveViewIntroWords}}">
</mat-form-field>
<mat-autocomplete #countAuto="matAutocomplete">
    <mat-option *ngFor="let option of options" [value]="option">
        {{ option }}
    </mat-option>
</mat-autocomplete>